module.exports = __webpack_public_path__ + "img/06.6dc29950.jpg";